/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { BaSeButton, BaSeIcon } from '@base/react';
import { useDisplay } from '../../hook/useDisplay';
import Modal from '../secrets/Modal';

import {
  AlignButton,
  Container,
  ContainerMobile,
  ContainerText,
  Content,
  ContentItem,
  ContentText,
  RoundButton,
} from './style';
import './style.css';

function EntrepreneurialCharacteristics() {
  const { isLargeDisplay } = useDisplay();
  const [linkSelected, setLinkSelected] = React.useState('');
  const [open, setOpen] = React.useState(false);

  const cards = [
    {
      id: '1',

      linkVideo: 'https://www.youtube.com/embed/AnUEsOB2sjg?enablejsapi=1',
      title: 'Busca de oportunidade e iniciativa',
      desc: 'O empreendedor deve ser proativo e antecipar o que está por vir, além de tomar iniciativa e buscar oportunidades de expandir seu negócio, criar novos produtos ou serviços e propor soluções inovadoras. É, em suma, a habilidade de encarar novos desafios.',
    },
    {
      id: '2',

      linkVideo: 'https://www.youtube.com/embed/g2rTbcwYal8?enablejsapi=1',
      title: 'Correr riscos calculados',
      desc: 'Ter um negócio é conviver com a incerteza, e é papel do empreendedor analisar os riscos, entender as ameaças e planejar essas decisões. É a habilidade de entender o ambiente à sua volta e buscar informações para tomar a melhor decisão.',
    },
    {
      id: '3',

      linkVideo: 'https://www.youtube.com/embed/yK4fkcXW514?enablejsapi=1',
      title: 'Exigência de qualidade e eficiência',
      desc: 'É olhar para o cliente e enxergar nos hábitos dele o tipo de relação que tem com os seus produtos e serviços, além de procurar entender todo o processo de venda, desde a criação até a entrega, para manter a qualidade e a eficiência do seu negócio. É a habilidade de sempre se adequar à realidade.',
    },
    {
      id: '4',

      linkVideo: 'https://www.youtube.com/embed/fs8EAGGd09A?enablejsapi=1',
      title: 'Persistência',
      desc: 'É preciso manter o foco e ter em mente que não se acerta todas as vezes, mas que é preciso continuar tentando. É a habilidade de não abrir mão de um objetivo e reconhecer que é preciso experimentar diferentes métodos e estratégias para alcançar sua meta.',
    },
    {
      id: '5',

      linkVideo: 'https://www.youtube.com/embed/2ZlNp3aZWrU?enablejsapi=1',
      title: 'Comprometimento',
      desc: 'Comprometer-se é estar disposto a não recuar diante de qualquer dificuldade, manter sua promessa de empreender, ser fiel às suas metas e objetivos e trabalhar de forma constante para alcançá-los.',
    },
    {
      id: '6',

      linkVideo: 'https://www.youtube.com/embed/-24BeWghnEs?enablejsapi=1',
      title: 'Busca de informação',
      desc: 'Manter-se informado sobre o mercado, o consumidor e os fornecedores é o caminho para encontrar oportunidades de negócios, elaborar planejamentos eficientes e ter uma base para tomar decisões em momentos de incerteza. As escolhas do empreendedor devem ser pautadas pela informação.',
    },
    {
      id: '7',

      linkVideo: 'https://www.youtube.com/embed/OJ7lJ3lP9J8?enablejsapi=1',
      title: 'Estabelecimento de metas',
      desc: 'As metas te estimulam a dar os passos certos e definir prazos. Representam o caminho até um sonho e é preciso saber como construí-las com clareza e objetividade. Por isso, o empreendedor deve saber usar o método SMART para suas metas serem eSpecíficas, Mensuráveis, Alcançáveis, Relevantes e Temporais.',
    },
    {
      id: '8',

      linkVideo: 'https://www.youtube.com/embed/bfKIO_CH9DI?enablejsapi=1',
      title: 'Planejamento e monitoramento sistemático',
      desc: 'Criar um planejamento eficiente é ser capaz de colocar no papel, de forma clara, onde se quer chegar e quais são os passos necessários para isso. Além disso, essa é uma ferramenta para diagnosticar erros e guiar ajustes no negócio. O empreendedor deve ter um pensamento estratégico, pois o planejamento é seu guia para ver o futuro do negócio.',
    },
    {
      id: '9',

      linkVideo: 'https://www.youtube.com/embed/8NfEMJHg61g?enablejsapi=1',
      title: 'Persuasão e rede de contatos',
      desc: 'O empreendedor deve saber se relacionar com as pessoas, pois ter uma rede de contatos é um dos maiores ativos para gerar oportunidades. Para isso, é preciso ter a capacidade de persuadir, se comunicar nos mais diversos ambientes e saber usar a empatia, sinceridade e credibilidade para se conectar com os outros.',
    },
    {
      id: '10',

      linkVideo: 'https://www.youtube.com/embed/fTOpehv4FqU?enablejsapi=1',
      title: 'Independência e autoconfiança',
      desc: 'Ser independente e aprender a confiar em si são atributos essenciais para lidar com desafios e oportunidades. Com essas habilidades, o empreendedor se torna mais seguro para lidar com assuntos ligados ao mercado, ao governo e às suas atividades no mundo dos negócios.',
    },
  ];

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <RoundButton
        className={className}
        style={{ ...style, display: 'hidden' }}
        onClick={onClick}
      >
        <BaSeIcon
          name="system/arrow-right-s-line"
          size="18"
          description="icon-lightulb-als"
          color="#0000c9"
        />
      </RoundButton>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <RoundButton
        className={className}
        style={{ ...style, display: 'hidden' }}
        onClick={onClick}
      >
        <BaSeIcon
          name="system/arrow-left-s-line"
          size="18"
          description="icon-lightulb-als"
          color="#0000c9"
        />
      </RoundButton>
    );
  }

  React.useEffect(() => {
    const updateDivStyles = () => {
      const divs = document.querySelectorAll('li > div');
      const slickDots = document.querySelector('ul.slick-dots');

      if (slickDots) {
        slickDots.style.display = 'flex';
        slickDots.style.justifyContent = 'center';
        slickDots.style.alignItems = 'center';
        slickDots.style.gap = '15px';
        slickDots.style.padding = '0';
        slickDots.style.marging = '0';
      }

      divs.forEach((div) => {
        const parentLi = div.parentElement;

        if (parentLi.classList.contains('slick-active')) {
          div.style.backgroundColor = 'black';
          div.style.width = '30px';
          div.style.marginLeft = '10px';
          div.style.marginRight = '10px';
        } else {
          div.style.backgroundColor = 'rgb(139, 153, 167)';
          div.style.width = '15px';
          div.style.margin = '0 20px';
        }
      });
    };

    updateDivStyles();

    const observer = new MutationObserver(() => {
      updateDivStyles();
    });

    observer.observe(document.body, {
      childList: true,
      attributes: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: !isLargeDisplay() ? <></> : <SampleNextArrow />,
    prevArrow: !isLargeDisplay() ? <></> : <SamplePrevArrow />,
    customPaging: (i) => (
      <div
        style={{
          height: '5px',
          borderRadius: 100,
          backgroundColor: '#8B99A7',
        }}
      >
        ‎
      </div>
    ),
    responsive: [
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,

          dots: false,
        },
      },
    ],
  };
  return (
    <Container id="3">
      <ContainerText>
        <p>
          Conheça as versões das <strong>10 características</strong> dos
          empreendedores de sucesso
        </p>
      </ContainerText>

      {isLargeDisplay() ? (
        <Slider {...settings}>
          {cards.map((item) => (
            <ContentItem number={item.id} key={item.id}>
              <Content>
                <ContentText>
                  <strong>{item.title}</strong>
                  <p>{item.desc}</p>
                </ContentText>
                <AlignButton>
                  <BaSeButton
                    value="Saiba mais"
                    borderRadius="max"
                    width="150px"
                    onClick={() => {
                      setLinkSelected(item.linkVideo);
                      setOpen(true);
                    }}
                    overrideColors={{
                      backgroundColor: '#FFC700',
                      foreground: '#0000C9',
                    }}
                  />
                </AlignButton>
              </Content>
            </ContentItem>
          ))}
        </Slider>
      ) : (
        <ContainerMobile>
          {cards.map((item, index) => (
            <ContentItem number={item.id} key={item.id}>
              <Content>
                <ContentText>
                  <strong>{item.title}</strong>
                  <p>{item.desc}</p>
                </ContentText>
                <AlignButton>
                  <BaSeButton
                    value="Saiba mais"
                    borderRadius="max"
                    width="100px"
                    onClick={() => {
                      setLinkSelected(item.linkVideo);
                      setOpen(true);
                    }}
                    overrideColors={{
                      backgroundColor: '#FFC700',
                      foreground: '#0000C9',
                    }}
                  />
                </AlignButton>
              </Content>
            </ContentItem>
          ))}
        </ContainerMobile>
      )}

      <Modal open={open} link={linkSelected} onClose={() => setOpen(false)} />
    </Container>
  );
}

export default EntrepreneurialCharacteristics;
